import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 402 free-plan-limit handler.
// - workspace / board hits open the FreeLimitDialog (via a window event).
// - storage hits (attachments) show a toast with a "Ver planes" action.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 402 && detail && typeof detail === "object" && detail.code === "free_limit") {
      if (detail.resource === "storage") {
        toast.error(detail.message || "Alcanzaste el límite del plan gratuito.", {
          action: {
            label: "Ver planes",
            onClick: () => { window.location.href = "/pricing"; },
          },
        });
      } else {
        window.dispatchEvent(new CustomEvent("sprintroll:free-limit", { detail }));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
